import { api } from '@/lib/axios';

export interface SampleType {
  id: number;
  name: string;
  accommodationCount: string;
}

export const fetchSampleTypes = async (): Promise<SampleType[]> => {
  try {
    const { data } = await api.get<SampleType[]>('/api/sample-types');
    return data;
  } catch (error) {
    throw new Error('Error al cargar los tipos de muestra');
  }
}; 